import React from "react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { siteUrl } from "../../utils/constants";
import type { StrapiBlock } from "../../types/strapi";
import TextFootNote from "./TextFootNote";
import { mediaUrl } from "../../utils/imageUtils";

interface TextBlockTwoProps {
  content?: StrapiBlock[];
}

const TextBlockTwo = ({ content }: TextBlockTwoProps) => {
  if (content) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner-wrapper">
              <div className="inner text-start">
                <BlocksRenderer
                  content={content}
                  blocks={{
                    image: ({ image }) => (
                      <div className="thumbnail">
                        <img
                          className="medium-centered-img mb-5"
                          src={mediaUrl(image.url.replace(
                            "/uploads/",
                            "/uploads/medium_"
                          ))}
                          alt={image.alternativeText || ""}
                        />
                      </div>
                    ),
                    link: ({ children, url }) => (
                      <a
                        className="theme-gradient"
                        href={url}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {children}
                      </a>
                    ),
                    quote: ({ children }) => (
                      <blockquote className="rn-blog-quote text-block-quote">
                        <p>
                          {children.map((child, index) => {
                            if (
                              typeof child?.props?.text === "string" &&
                              child?.props?.text?.indexOf("footnote=") !== -1
                            ) {
                              return (
                                <TextFootNote
                                  key={`footnote-${index}`}
                                  tbFootNote={child?.props?.text?.split(
                                    "footnote="
                                  )}
                                />
                              );
                            }

                            return child;
                          })}
                        </p>
                      </blockquote>
                    ),
                    paragraph: ({ children }) => {
                      const mappedChildren = children.map(
                        (child, mappedChildIndex) => {
                          if (
                            typeof child?.props?.text === "string" &&
                            child?.props?.text?.indexOf("footnote=") !== -1
                          ) {
                            return (
                              <TextFootNote
                                key={mappedChildIndex}
                                tbFootNote={child?.props?.text?.split(
                                  "footnote="
                                )}
                              />
                            );
                          }

                          return child;
                        }
                      );

                      return (
                        <p className="text-neutral900 max-w-prose">
                          {mappedChildren}
                        </p>
                      );
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return "";
};

export default TextBlockTwo;
